<template>
  <div class="select-field mb-0" :class="open ? 'active' : null">
    <div class="display mb-0" @click="open = !open">
      {{ activeOption.text || activeOption }}
      <i class="material-icons">keyboard_arrow_down</i>
    </div>
    <ul class="options">
      <li
        class="option mb-1"
        v-for="(option, index) in options"
        :key="index"
        :class="index === activeIndex ? 'active' : null"
        @click="handleOptionClicked(index)"
      >
        {{ option.text || option }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "SelectField",
  props: {
    options: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      activeIndex: 0,
      activeOption: this.options[0],
      open: false
    };
  },
  created() {
    this.parseOptions();
  },
  methods: {
    parseOptions(options = this.options) {
      return options;
    },

    handleOptionClicked(index) {
      this.activeOption = this.options[index]; // so as to get the content
      this.activeIndex = index;
      this.open = false;

      this.$emit('select', this.activeIndex)
    }
  }
};
</script>

<style lang="scss" scoped>
$primary-accent-color: #03efa2;
$active-option-color: #03efa2;

.select-field {
  i {
    position: absolute;
    top: 50%;
    right: 8px;
    transition: inherit;
    transform: translateY(-50%);
  }

  .display {
    position: relative;
  }
  .options {
    margin-top: 0;

    .option:last-child {
      margin-bottom: 0 !important;
    }
  }

  &.active {
    i {
      transform: translateY(-50%) rotate(180deg);
    }

    .options {
      margin-top: 5px;
      // max-height: 123px !important;
    }
  }
}
</style>

<style lang="scss">
.theme-dark {
  .options {
    color: $text-color-dark !important;
    background-color: $dark-light-color !important;
  }
}
</style>
